import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import {useApolloClient} from '@apollo/client';

import { 
  fetchOneDomainInstance,
  OperationTargets
} from '../../api/CommonCrudOperations'

import LTRDomainObjectInfo from '../shared/domains/LTRDomainObjectInfo';
// Our labels in the Info Table
const labels = {
  type: "TYPE",
  description: "DESCRIPTION",
  digital: "DIGITAL",
  location: "LOCATION",
  notes: "NOTES"
}

export const prepareTableRowInfo = (doc) => {
  // prepare table data for show
  let messageAction = '';
  let messageDoc = '';
  if (doc.actionItems) {
    messageAction = doc.actionItems.length === 0 ? "This document has NO action items" :
    "This document has " + doc.actionItems.length + " action items";
  }
  if (doc.attachments) {
    messageDoc = doc.attachments.length === 0 ? "This document has NO attached files":
    "This documnent has " + doc.attachments.length + " attached files"
  }
  const tableInfo = {
    name: doc.name,
    actionItemMessage: messageAction,
    documentsMessage: messageDoc,
    fieldData : [
      {
        field: labels.type,
        value: doc.type
      },
      {
        field: labels.description,
        value: doc.description
      },
      {
        field: labels.digital,
        value: doc.digital ? "This is a digital document" : "This is NOT a digital document"
      },
      {
        field: labels.location,
        value: doc.location
      },
      {
        field: labels.notes,
        value: doc.notes
      },
    ]
  }

  return tableInfo;  
}

const useDocumentFetch = (client, domainId, updateFn) => {
  const [document, setDocument] = useState(null);
  
  useEffect(() => {
    const fetchDocument = () => { 
      fetchOneDomainInstance(client, OperationTargets.Documents, domainId)
      .then(result => { 
        const doc = result.item;
        setDocument(doc);
        updateFn(doc);
      })
      .catch(error => {
        console.log(error) 
      });
    }

    if (document === null && domainId !== null) {
      fetchDocument()
    }  
  }, [client, updateFn]);
};

const DocumentInfo = (props) => {
  const client = useApolloClient();

  const [showInfoDialogOpen, setShowInfoDialogOpen] = useState(false);
  const [tableInfo, setTableInfo] = useState(null);
  const [document, setDocument] = useState(null);

  const handleShowInfoClose = () => {
    setShowInfoDialogOpen(false);
    // notify the client
    props.handleClose();
  }

  useDocumentFetch(client, props.domainId, (fetchedData) => {
    if (fetchedData !== null) {
      setDocument(fetchedData);
      const info = prepareTableRowInfo(fetchedData);
      setTableInfo(info);
      setShowInfoDialogOpen(true);
    }
  });

  if (tableInfo === null) {
    return null;
  }

  return (
    <React.Fragment>  
      {showInfoDialogOpen ? (
        <LTRDomainObjectInfo
          open = {props.open}
          title = {document.name}
          tableData = {tableInfo}
          handleClose = {handleShowInfoClose}
        />): null
      }
    </React.Fragment>
  )
}

DocumentInfo.propTypes = {
  open: PropTypes.bool.isRequired,
  domainId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default (DocumentInfo);